import { createAction } from '@saucelabs/sl-util-redux';

import * as constants from './types';

export const sortTestCases = createAction(constants.SORT_TEST_CASES);
export const setTestCaseQueryType = createAction(constants.SET_TEST_CASE_QUERY);
export const handleChangePagination = createAction(constants.CHANGE_PAGINATION);
